import React, { useRef } from 'react';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import SupportPopup from 'apps/auth/components/utils/popup/SupportPopup';
import { AUTH_GA_POCKET } from 'apps/auth/constants/UrlConstants';
import { usePageMessages, useExtra } from 'apps/auth/hooks/selectors';

const GaStatusFailed = () => {
    const { headerTitle, statusText, statusSupportTitle, statusCancelTitle } = usePageMessages();
    const { pocketId } = useExtra();
    const popupRef = useRef(null);

    return (
        <>
            <InfoPage
                animatedIconFail
                headerText={headerTitle}
                secondaryText={<DangerouslyHtml dangerouslyHtml={statusText} />}
                buttonRowCaption={statusSupportTitle}
                buttonRowOnClick={(e) => {
                    e.preventDefault();
                    popupRef.current?.open(<SupportPopup popupRef={popupRef} />);
                }}
                primaryButtonCaption={statusCancelTitle}
                primaryButtonType="link"
                primaryButtonLink={`${AUTH_GA_POCKET}${pocketId}`}
            />
            <PopupNew ref={popupRef} />
        </>
    );
};

export default GaStatusFailed;
